export class AllocationRequestTypeExceptedTaskType {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
